import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  deletePaper: {
    margin: 'auto',
    width: '40%',
    maxWidth: 500,
    padding: 24,
    marginTop: '15vh',
    zIndex: 1,
    outline: 'none',
    position: 'relative',
    borderRadius: 16,
    [theme.breakpoints.down('sm')]: {
      width: '90%',
      marginTop: '10vh',
      marginBottom: '10vh'
    }
  },
  deleteIcon: {
    margin: 'auto',
    fontSize: 80,
    position: 'absolute',
    backgroundColor: theme.palette.type === 'dark' ? '#101010' : '#7f7f7f',
    padding: 10,
    borderRadius: '50%',
    top: -42,
    left: 'calc(50% - 40px)'
  },
  title: {
    marginTop: 30,
    textAlign: 'center',
    marginBottom: 24
  },
  description: {
    textAlign: 'center',
    marginBottom: 8
  },
  deleteButton: {
    marginLeft: 8
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  transactionSignButton: {
    width: 'calc(100% - 1px)',
    height: 'calc(100% - 2px)',
    fontSize: 30,
    marginTop: -1,
    marginLeft: 1,
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6
  },
  transactionSignButtonNegative: {
    background: 'linear-gradient(to right, #ffdcdc , white, #ffdcdc)'
  },
  transactionSignButtonPositive: {
    background: 'linear-gradient(to right, #dcffdd , white, #dcffdd)'
  }
}))

export default useStyles
